<template>
  <div class="cardlist">
    <div class="cardlist-title">    
      <label>{{ $t(category)}}</label>
    </div>
    <div class="dropdownaction_icon" @click="toggleMultiselectDropdown">
      <span class="cancelblock" v-if="clearSelected && selected && selected.length !== 0" @click="updateMethod([],$event);$emit('clearAllGA')">
        <svgicon name="cancelblack" width="8" height="8" :original="true" />
      </span>
      <span class="cancelblock" v-else>
        <svgicon name="fill_arrow" width="8" height="8" :original="true" />
      </span>
    </div>
    <div class="cardlist-dropdown">
      <Multiselect ref="multiselectref" :value="selected" :options="getList" :multiple="true" :disabled="disableGates"
      :close-on-select="false" :clear-on-select="false" :preserve-search="true" :allow-empty="this.allowEmpty"
      :placeholder="placeholder" label="tlabel" track-by="id" :preselect-first="true"
      @input="updateMethod">
        <template slot="selection" slot-scope="{ values, search, isOpen }">
          <span class="multiselect__single" v-if="values.length === 1 &amp;&amp; !isOpen">
            {{ values[0].name }}</span>
          <span class="multiselect__single" v-else-if="values.length &amp;&amp; !isOpen">
            {{ adjustOptionsLength(values) }} options selected</span>
        <div class="dropdownaction_icon" @click="toggleMultiselectDropdown">
          <span class="arrowblock">
            <svgicon v-if="values.length === 0" name="fill_arrow" width="9" height="9" :original="true" />
          </span>
          <div class="dropdownaction_icon" @click="toggleMultiselectDropdown">
            <span class="arrowblock">
              <svgicon v-if="values.length === 0" name="fill_arrow" width="9" height="9" :original="true" />
            </span>
          </div>
        </div>
        </template>
      </Multiselect>
	  </div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  props: {
    disableGates: {
      type: Boolean,
      default: false,
    },
    options: {
      type: [Array, Object],
    },
    selected: {},
    category: "",
    placeholder: "",
    maxSelectionAllowed: {
      type: Number,
      required: false,
    },
    clearSelected: {
      type: Boolean,
      default: false,
    },
    selectAllOption: {
      type: Boolean,
      default: false,
    },
    defaultSelectAll: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      value: [],
      list: [],
      selectedAll: false,
      selectAll: {
        id: 0,
        name: "Select All"
      },
    }
  },
  created() {
    this.createList();
  },
  computed: {
    getList() {
      if (this.options && this.options.length) {
        return this.createList().map(option => {
          if (option.tlabel) {
            option.tlabel = this.$t(option.tlabel);
          } else {
            option.tlabel = option.name;
          }
          return option;
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    createList() {
      this.list = this.options.map(val => Object.assign(val, { $isDisabled : false }));
    if (this.selectAllOption && !this.maxSelectionAllowed) {
      if (this.list[0].name !== "Select All") {
        this.list.unshift(this.selectAll);
      }
      if (this.defaultSelectAll
        && !this.selected.find(value =>
          value.name === this.selectAll.name)) {
        if(this.selected.length < (this.list.length - 1)){
          this.selectedAll = false;
        } else {
          this.selected.unshift(this.selectAll);
          this.selectedAll = true;
        }
      }
    }
    return this.list;
    },
    adjustOptionsLength(values) {
      const valuesLength = values.length;
      return values.find(value => value.name === this.selectAll.name) ?
        valuesLength - 1 : valuesLength
    },
    updateMethod(values,event= null) {
      if(this.maxSelectionAllowed) {
        if(values.length === this.maxSelectionAllowed) {
          this.list = this.list.map(val => {
            if(!values.includes(val)) {
              return Object.assign(val, { $isDisabled : true });
            } else {
              return val;
            }
          });
        } else {
          //clearing all the disabled items
          this.list = this.options.map(val => Object.assign(val, { $isDisabled : false }));
        }
      }
      /*
        for multi select list use defaultSelectAll as true
        when default selection is expected as all option
      */
      const selectAllCheckFlag =  values.find(value =>
        value.name === this.selectAll.name)
      if (selectAllCheckFlag) {
        if (!this.selectedAll) {
          values = this.list;
          this.selectedAll = true;
        }
        if(values.length < this.list.length){
          values =  values.filter((item) => item.id !== 0);
          this.selectedAll = false;
        }
      }
      if (!selectAllCheckFlag) {
        if (this.selectedAll) {
          if (this.selectAllOption && !this.defaultSelectAll) {
            values = !this.allowEmpty ? [this.options[0]] : [];
          } else {
            values = !this.allowEmpty ? [this.options[1]] : [];
          }
          this.selectedAll = false;
        }
        if (values.length === this.list.length - 1) {
          values.unshift(this.selectAll);
          this.selectedAll = true;
        }
      }
      this.$emit('updateOption',values, this.category);
      if(event) {
        event.stopPropagation();
      }
    },
    toggleMultiselectDropdown() {
      this.$refs.multiselectref.toggle();
    }
  },
}

</script>
